import { render, staticRenderFns } from "./OptonsCategoriCard.vue?vue&type=template&id=15a0c207&scoped=true"
import script from "./OptonsCategoriCard.vue?vue&type=script&lang=js"
export * from "./OptonsCategoriCard.vue?vue&type=script&lang=js"
import style0 from "./OptonsCategoriCard.vue?vue&type=style&index=0&id=15a0c207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0c207",
  null
  
)

export default component.exports